import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EducationReimbursement, Reimbursement, StateLicensureReimbursement } from '../models/reimbursement.model';
import { MarginCalculatorBaseService } from './margin-calculator-base.service';

@Injectable({
    providedIn: 'root'
})
export class MarginCalculatorReimbursementService extends MarginCalculatorBaseService {
    constructor(private readonly _http: HttpClient) {
        super();
    }

    getReimbursements(): Observable<Reimbursement> {
        return this._http.get<Reimbursement>(`${this.coreApiPath}/margin-calculator/reimbursements`).pipe(
            map((response) => {
                response.educationReimbursements.forEach((value: EducationReimbursement, index: number) => {
                    value['selected'] = false;
                });

                // Need to keep the IDs different from education reimbursements
                response.stateLicensureReimbursements.forEach((value: StateLicensureReimbursement, index: number) => {
                    value['selected'] = false;

                    // TODO: Refactor this logic or move to the backend
                    value.id = Math.floor(Math.random() * (999 - value.code.charCodeAt(0)) + value.code.charCodeAt(1));
                });

                return response;
            })
        );
    }
}
